var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74414 0.675781L11.6953 5.60156C11.9238 5.85547 11.9238 6.23633 11.6953 6.46484L11.1113 7.04883C10.8828 7.27734 10.502 7.27734 10.248 7.04883L6.3125 3.13867L2.40234 7.04883C2.14844 7.27734 1.76758 7.27734 1.53906 7.04883L0.955078 6.46484C0.726562 6.23633 0.726562 5.85547 0.955078 5.60156L5.90625 0.675781C6.13477 0.447266 6.51563 0.447266 6.74414 0.675781Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.3060b362ce8e36a92626031202e16e44.svg";
export { ForwardRef as ReactComponent };